import * as React from "react";
const SvgUpArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 7 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.37466 3.49208V10H2.62534V3.49208H0L3.5 0L7 3.49208H4.37466Z", fill: "currentColor" }));
export default SvgUpArrow;
